export const state = {
  parkings: [],
  parking_items: [
    {
      description: "PARKING FEE",
      truck_id: "",
      unit_price: "",
      total_price: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/parkings/state.js